import { mdiClockOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { env, loginMessages, maintenanceMessages } from 'azshared';
import React from 'react';
import { useIntl } from 'react-intl';
import packageJson from '../../../package.json';
import { Card } from '../../components/card/card';
import { LoginContainer } from '../user-access/login-container/login-container';
import '../user-access/login-page/login-page.scss';
import { MaintenanceIllustration } from './maintenance-illustration';
import './maintenance-page.scss';

/** Same layout, card and text styles as the login page, with the maintenance notice in place of the login form. */
function MaintenancePage() {
  const { formatMessage } = useIntl();

  return (
    <LoginContainer>
      <main className='login-page maintenance-page'>
        <Card title='MyAzimut' disclaimer={formatMessage(loginMessages.assistanceDisclaimer)}>
          <MaintenanceIllustration />
          <h3 className='maintenance-title'>{formatMessage(maintenanceMessages.title)}</h3>
          <p className='maintenance-description'>{formatMessage(maintenanceMessages.description)}</p>
          <div className='maintenance-note'>
            <span className='maintenance-note-icon'>
              <Icon path={mdiClockOutline} size={0.9} />
            </span>
            <p>{formatMessage(maintenanceMessages.subtitle)}</p>
          </div>
        </Card>
        {env.ambient !== 'prod' && (
          <div className='login-version'>
            v{packageJson.version} - {env.ambient.toUpperCase()}
          </div>
        )}
      </main>
    </LoginContainer>
  );
}

export default MaintenancePage;
